import legalPenalties from '@/assets/images/landingPage/eaa/legalPenalties.png';
import marketReach from '@/assets/images/landingPage/eaa/marketReach.png';
import userExperience from '@/assets/images/landingPage/eaa/userExperience.png';

export const benefitsImages = [
  {
    key: 'legal_penalties',
    src: legalPenalties,
  },
  {
    key: 'market_reach',
    src: marketReach,
  },
  {
    key: 'user_experience',
    src: userExperience,
  },
];
